exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".shortlisted-row{background-color:#e6ffed!important}.w-90 .modal-dialog{max-width:90%!important;margin:0 auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51ce511e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/payment/slinePaymentSortList.vue
// module id = 1598
// module chunks = 0